var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgKn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.333h512V426.67H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M512 85.33H0v341.333"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M446.679 85.33h-28.845L0 363.887v62.776h94.165L512 148.105V85.33z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M512 85.33h-65.321L0 383.117v43.546h65.32L512 128.876z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M186.241 265.94l18.902 14.53 19.659-13.487-7.977 22.467 18.902 14.53-23.832-.644-7.979 22.467-6.751-22.867-23.833-.644 19.66-13.487zm102.941-70.617l18.902 14.53 19.659-13.487-7.977 22.467 18.902 14.53-23.833-.645-7.978 22.468-6.752-22.867-23.832-.644 19.66-13.487z",
  fill: "#f0f0f0"
})));

export default SvgKn;